import React from "react";

import useStyles from "../styles";

interface Props {
  svgB64: string;
}

const Image = ({ svgB64 }: Props) => {
  const classes = useStyles();
  return (
    <div>
      <img
        src={"data:image/svg+xml;base64," + svgB64}
        className={classes.image}
        alt="msanalyzer svg"
      ></img>
    </div>
  );
};

export default Image;
